import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import SemiBold from "./TicketSemiBold.woff2";

export const TicketSemiBoldFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: SemiBold },
];
